export const defaultColorTheme: ColorThemes = {
  dark: {
    error: {
      main: '#ed4747',
    },
    warning: {
      main: '#eded47',
    },
    success: {
      main: '#78FFB6',
    },
    info: {
      main: '#478fed',
    },
    primary: {
      main: '#0D0101',
    },
    secondary: {
      main: '#FFA6D1',
    },
    tertiary: {
      main: '#FFCF87',
    },
    text: {
      main: '#0D0101',
    },
  },
  light: {
    error: {
      main: '#ed4747',
    },
    warning: {
      main: '#eded47',
    },
    success: {
      main: '#78FFB6',
    },
    info: {
      main: '#478fed',
    },
    primary: {
      main: '#FFA6D1',
    },
    secondary: {
      main: '#0D0101',
    },
    tertiary: {
      main: '#FFCF87',
    },
    text: {
      main: '#0D0101',
    },
  },
};

export default defaultColorTheme;
